import { render, staticRenderFns } from "./ModalEditUserPersonalStory.vue?vue&type=template&id=1c813f2e&"
import script from "./ModalEditUserPersonalStory.vue?vue&type=script&lang=js&"
export * from "./ModalEditUserPersonalStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports